/**
 * 订单详情菜品行：免费菜品判定与列表过滤（与 CWA 支付分单「显示免费菜品」一致：单价为 0）。
 * 额外费用（`dish_type === -1`）不参与免费菜判定，始终展示（与 PC `ORDER_DETAIL_DISH_TYPE_EXTRA` 一致）。
 */

/** 订单详情「额外费用」：`DishType.EXTRA === -1` */
export const ORDER_DETAIL_DISH_TYPE_EXTRA = -1;

/** 订单详情菜品行中用于判定免费菜的最小字段 */
export type OrderDetailDishFreeLike = {
    /** 菜品单价（接口 `product_price`） */
    product_price?: number | null;
    /** 菜品类型：-1=额外费用，不参与免费菜过滤 */
    dish_type?: number | null;
};

/**
 * 是否为额外费用行（`dish_type === ORDER_DETAIL_DISH_TYPE_EXTRA`）。
 * @param dish - 订单详情菜品行
 */
export function isOrderDetailExtraFeeDish(dish: { dish_type?: number | null }): boolean {
    return dish.dish_type === ORDER_DETAIL_DISH_TYPE_EXTRA;
}

/**
 * 是否为免费菜品：`product_price` 为 0 视为免费；额外费用行一律不算免费菜。
 * @param dish - 订单详情菜品行
 */
export function isOrderDetailFreeDish(dish: OrderDetailDishFreeLike): boolean {
    if (isOrderDetailExtraFeeDish(dish)) {
        return false;
    }
    const price = Number(dish.product_price ?? 0);
    return !Number.isNaN(price) && price === 0;
}

/**
 * 列表是否含至少一行可隐藏的免费菜品（额外费用不计入）。
 * @param list - 订单详情菜品明细
 */
export function orderDetailDishListHasFreeDishes(list: OrderDetailDishFreeLike[]): boolean {
    return list.some(isOrderDetailFreeDish);
}

/**
 * 按「是否展示免费菜品」过滤明细；`showFreeDishes === false` 时剔除普通免费菜，额外费用始终保留。
 * @param list - 原始菜品明细（保持接口顺序）
 * @param showFreeDishes - 为 true 时展示全部行；为 false 时隐藏免费菜
 */
export function filterOrderDetailDishesByFreeVisibility<T extends OrderDetailDishFreeLike>(
    list: T[],
    showFreeDishes: boolean,
): T[] {
    if (showFreeDishes) {
        return list;
    }
    return list.filter((item) => isOrderDetailExtraFeeDish(item) || !isOrderDetailFreeDish(item));
}
